/** 所有通用图片上传入口共用的单文件大小上限（MB）。 */
export const IMAGE_UPLOAD_SIZE_LIMIT_MB = 30;

/** 输入框媒体数量上限，文件桶同时统计普通文档与音频。 */
export const INPUT_MEDIA_UPLOAD_COUNT_LIMITS = {
  maxImageNum: 30,
  maxVideoNum: 10,
  maxDocumentNum: 10,
} as const;

/** Team Flow 画布单次上传批次的分类数量上限。 */
export const TEAM_FLOW_UPLOAD_COUNT_LIMITS = {
  image: 30,
  video: 10,
  audio: 10,
  markdown: 10,
} as const;

export type TeamFlowUploadCategory = keyof typeof TEAM_FLOW_UPLOAD_COUNT_LIMITS;

interface CategorizedUploadItem {
  category: TeamFlowUploadCategory;
}

export interface CategorizedUploadLimitResult<T> {
  accepted: T[];
  rejected: T[];
}

/** 按类型独立截取单次上传批次，并保持原始文件顺序。 */
export function limitUploadItemsByCategory<T extends CategorizedUploadItem>(
  items: T[],
): CategorizedUploadLimitResult<T> {
  const counts: Record<TeamFlowUploadCategory, number> = {
    image: 0,
    video: 0,
    audio: 0,
    markdown: 0,
  };
  const accepted: T[] = [];
  const rejected: T[] = [];

  items.forEach((item) => {
    if (counts[item.category] >= TEAM_FLOW_UPLOAD_COUNT_LIMITS[item.category]) {
      rejected.push(item);
      return;
    }
    counts[item.category] += 1;
    accepted.push(item);
  });

  return { accepted, rejected };
}
